<div class="folders-tab" [nbSpinner]="!!(saving$ | async)">
  @if (folderInstancesDto()) {
    <form [formGroup]="attachmentForm">
      <wr-attachment-folder-tree formControlName="attachmentFolderInstances"
                                 [allowSubFolderManagement]="canEditFolderContents() && isEditing() && !isContractor()"
                                 [allowAttachmentEditing]="!isContractor()"
                                 (createSubFolder)="openCreateSubFolderDialog($event)"
                                 (renameSubFolder)="openRenameSubFolderDialog($event)"
                                 (deleteSubFolder)="confirmDeleteSubFolder($event)"></wr-attachment-folder-tree>
    </form>
  }
</div>
